import { useMutation } from "@apollo/client";
import { CREATE_STOCK_UNIT } from "../stock-unit.queries";
import { CreateStockUnitInput } from "../../../__generated__/globalTypes";
import {
  CreateStockUnitMutation,
  CreateStockUnitMutationVariables,
} from "../../../__generated__/CreateStockUnitMutation";

export const useCreateStockUnitFromScan = () => {
  const [mutate, { loading }] = useMutation<
    CreateStockUnitMutation,
    CreateStockUnitMutationVariables
  >(CREATE_STOCK_UNIT, {
    refetchQueries: ["StockUnitsQuery"],
  });

  const createFromScan = async (input: CreateStockUnitInput) => {
    try {
      const { data } = await mutate({ variables: { input } });
      if (!data?.createStockUnit?.ok) {
        return {
          success: false,
          error: data?.createStockUnit?.error ?? "Erreur inconnue",
        };
      }
      return { success: true, id: data.createStockUnit.id };
    } catch (error: any) {
      return {
        success: false,
        error: error?.message ?? "Une erreur est survenue",
      };
    }
  };

  return { createFromScan, loading };
};
